import Cookies from 'js-cookie';


export const SET = 'session/set';
export const CLEAR = 'session/clear';


const initialState = Cookies.getJSON('session') || null;
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case SET:  return action.payload;
        case CLEAR:  return null;
        default: return state;
    }
}
